import { CesuMileageReimbursementBase } from '../json-schemas/base/cesu_mileage_reimbursement'
import { I18nService } from '../utils/i18n.service'
import { toUpperCaseFirst } from '../utils/lodash.service'
import i18nScopedData from './cesu-mileage-reimbursements.service.yml'

const i18nScoped = new I18nService(i18nScopedData)

export function cesuMileageReimbursementI18nApplyness (applyness: CesuMileageReimbursementBase['applyness'], { capitalize = true } = {}): string {
  const translated = i18nScoped.t(`applyness.${applyness}`)
  return capitalize ? toUpperCaseFirst(translated) : translated
}